import { useRef, useState } from 'react'
import { Download, HardDriveDownload, Upload, X } from 'lucide-react'

function stamp() {
  const date = new Date()
  const pad = (value) => String(value).padStart(2, '0')
  return date.getFullYear() + pad(date.getMonth() + 1) + pad(date.getDate()) + '-' + pad(date.getHours()) + pad(date.getMinutes())
}

export default function LocalStoreModal({ canvas, aiSettings, onImport, onBackupSaved, onClose, notify }) {
  const fileRef = useRef(null)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  function exportBackup() {
    const payload = {
      app: 'page-isle',
      version: 2,
      exportedAt: new Date().toISOString(),
      canvas,
      aiSettings,
    }
    const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' })
    const url = URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = 'page-isle-backup-' + stamp() + '.json'
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
    URL.revokeObjectURL(url)
    notify('备份文件已交给浏览器保存，请选择你要存放的位置。')
    if (onBackupSaved) onBackupSaved()
  }

  function importBackup(event) {
    const file = event.target.files && event.target.files[0]
    if (!file) return
    setBusy(true)
    setError('')
    const reader = new FileReader()
    reader.onload = () => {
      try {
        const parsed = JSON.parse(String(reader.result))
        const validCanvas = parsed && parsed.canvas && Array.isArray(parsed.canvas.cards)
        const validProjects = parsed && Array.isArray(parsed.projects)
        if (!validCanvas && !validProjects) {
          setError('文件不是有效的页屿备份（缺少画板数据）。')
          setBusy(false)
          return
        }
        if (validProjects && !validCanvas) {
          parsed.canvas = { cards: [], links: [], books: [] }
        }
        onImport(parsed)
        notify('已从本地文件恢复画板，并同步到云端。')
      } catch (err) {
        setError('读取失败：' + (err && err.message ? err.message : '文件格式不正确'))
      } finally {
        setBusy(false)
        event.target.value = ''
      }
    }
    reader.onerror = () => {
      setError('读取文件失败，请重试。')
      setBusy(false)
    }
    reader.readAsText(file)
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="history-modal local-store-modal" onClick={(event) => event.stopPropagation()}>
        <header>
          <div>
            <h3>本地存储</h3>
            <p>数据平时自动同步在你的云端账号里；这里可以另存一份到本地，位置由你决定。</p>
          </div>
          <button className="icon-button" onClick={onClose} aria-label="关闭"><X size={18} /></button>
        </header>
        <div className="local-store-body">
          <button className="local-store-card" onClick={exportBackup}>
            <span className="local-store-card__icon"><Download size={20} /></span>
            <div>
              <strong>导出备份</strong>
              <p>把画板上的全部卡片、关联线、成书与 AI 设置打包成一个 JSON 文件，浏览器会询问你保存到哪里。</p>
            </div>
          </button>
          <button className="local-store-card" onClick={() => fileRef.current && fileRef.current.click()}>
            <span className="local-store-card__icon"><Upload size={20} /></span>
            <div>
              <strong>从文件恢复</strong>
              <p>选择之前导出的备份文件，恢复画板内容（会替换当前数据并同步到云端）。</p>
            </div>
          </button>
          <input ref={fileRef} type="file" accept="application/json,.json" style={{ display: 'none' }} onChange={importBackup} aria-label="选择备份文件" />
          {error ? <p className="auth-error">{error}</p> : null}
          {busy ? <p className="inspector-muted-line">正在读取文件…</p> : null}
        </div>
      </div>
    </div>
  )
}
